import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { LOGIN_ROUTE } from "../../config/RoutesConstants"
import {
  Field,
  reduxForm,
  formValueSelector,
  change,
  getFormValues
} from "redux-form";
// import { TextField, Select } from "redux-form-material-ui";
import { required , typeInteger, typeIntegerOrDecimal, validateEmail, } from "../../common/Validations";
import { 
  Container, 
  Badge,
  Box, 
  Button,
  FormControl,
  FormHelperText,
  IconButton,
  InputLabel,
  Grid,
  Paper,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableFooter,
  TablePagination,
  Typography, 
  Tooltip,
  Input,
  InputAdornment,
  Icon,
  SvgIcon,
  Select,
  Toolbar,
  MenuItem,
  Tab,
  Tabs,
} from "@material-ui/core"
import ColorField from "../../components/ColorField/ColorField"
import IconPicker from "../../components/IconPicker/IconPicker"
import { withTheme } from "@material-ui/core/styles"
import BackIcon from '@material-ui/icons/ArrowBackRounded';
import SearchIcon from '@material-ui/icons/Search';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import ExcelIcon from '@material-ui/icons/AttachFile';
import Util, { ERROR, SUCCESS, WARNING, handleSubmitFail } from '../../common/Util'
import { actionSaveTickets, actionGetTicketTypes} from '../../actions/RestaurantActions'
import { actionGetUsersByEmailOrDU, actionGetUsersFromExcel } from '../../actions/UserActions'
let _handleSubmitFail;

class AddEditTicket extends React.PureComponent{
  constructor(props){
    super(props)
    this.state={ticketTypeSel:null, tickets:null, searchField:"E-mail", search:"", 
                tabSel:0, userSel:null, ticketList:[], page:0, rowPerPage:5, count:0,
                ticketTypeError:"", emailError:"", usersData:null, tableTabSel:0, ticketCount:1, ticketCountError:""}
    this.getTycketTypeSuccess=this.getTycketTypeSuccess.bind(this)
    this.onChangeSearch=this.onChangeSearch.bind(this)
    this.onChangeTicketType=this.onChangeTicketType.bind(this)
    this.onChangeCount=this.onChangeCount.bind(this)
    this.onSearchUser=this.onSearchUser.bind(this)
    this.onClean=this.onClean.bind(this)
    this.onSave=this.onSave.bind(this)
    this.renderBulkForm=this.renderBulkForm.bind(this)
    this.renderIndividualForm=this.renderIndividualForm.bind(this)
    this.renderTableBody=this.renderTableBody.bind(this)
    this.getUsersByEmailOrDUSuccess=this.getUsersByEmailOrDUSuccess.bind(this)
    this.isValidSearch=this.isValidSearch.bind(this)
    this.isValidForm=this.isValidForm.bind(this)
    this.onClickUploadExcel=this.onClickUploadExcel.bind(this)
    this.onUploadExcel=this.onUploadExcel.bind(this)
    this.uploadAttachCallback=this.uploadAttachCallback.bind(this)
    _handleSubmitFail=this.handleSubmitFail.bind(this)
    this.inputFile
  }

  componentWillMount(){
    if(!this.props.login){
      this.props.history.replace(LOGIN_ROUTE);
    }
    this.props.actionGetTicketTypes(this.getTycketTypeSuccess, this.getTicketsError)
  }
  
  onChangePage(evt=null, newPage=0){
    let from=newPage*this.state.rowPerPage
    let end=from+this.state.rowPerPage
    //console.log("FILTER", this.state.filter)
    //let filter = new RegExp(this.state.filter,"ig")
    let tickets = this.state.tableTabSel?this.state.usersData.usersToInvite:this.state.usersData.users//this.state.ticketList//.filter((t)=>{console.log("OWNER",t.tktOwnerDU, filter); return t.tktOwnerDU.match(filter)})
    let count = tickets.length
    tickets=tickets.slice(from, end)
    this.setState({page:newPage, count:count, tickets:tickets})
  }

  onChangeRowsPerPage(evt){
    let from=this.state.page*evt.target.value
    let end=from+evt.target.value
   // let filter = new RegExp(this.state.filter,"ig")
    let tickets = this.state.tableTabSel?this.state.usersData.usersToInvite:this.state.usersData.users//this.state.ticketList//.filter((t)=>{return t.tktOwnerDU.match(filter)})
    let count = tickets.length
    tickets=tickets.slice(from, end)
    this.setState({rowPerPage:evt.target.value, count:count, tickets:tickets})
  }

  getTycketTypeSuccess(){
      if(this.props.ticketTypeList&&this.props.ticketTypeList>0){
        this.setState({ticketTypeSel:this.props.this.props.ticketTypeList[0]})
      }
  }
  
  handleSubmitFail(error){
    console.log("ERROR EN EL SUBMIT", error)
  }

  onClean(){
    this.setState({ticketTypeSel:null, tickets:null, searchField:"E-mail", search:"", 
    tabSel:0, userSel:null, ticketList:[], page:0, rowPerPage:5, count:0,
    ticketTypeError:"", emailError:"", usersData:null, tableTabSel:0, ticketCount:1, ticketCountError:""})
  }
  
  isValidForm(){
    let isValid = true
    if(this.state.tabSel){
      if(!this.state.usersData||(this.state.usersData.users.length==0&&this.state.usersData.usersToInvite.length==0)){
        Util.showNoty(ERROR,"Debe agregar tickets")
        isValid = false
      }
    }else{
      if(!this.state.ticketTypeSel){
        this.setState({ticketTypeError:"Debe seleccionar un tipo de ticket"})
        isValid = false
      }
      if(!this.state.userSel){
        this.setState({emailError:"Debe buscar un usuario"})
        isValid = false
      }
    }
    return isValid
  }

  onSave(){
    if(this.isValidForm()){
      let tickets = this.state.usersData
      // if(!this.state.tabSel){
      //   tickets =[{
      //     tktTypeId: this.state.ticketTypeSel.id,
      //     tktPrice: this.state.ticketTypeSel.tktPrice,
      //     tktDisplayName: this.state.ticketTypeSel.tktDisplayName,
      //     tktCategory: this.state.ticketTypeSel.tktCategory,
      //     ...this.state.userSel
      //   }]
      // }
      let successMessage=tickets.length>1?"Los tickets se guardaron correctamente.":"El ticket se guardó correctamente."
      this.props.actionSaveTickets(tickets
        , ()=>{Util.showNoty(SUCCESS, successMessage); this.props.history.goBack()}
        , (e)=>{
          console.log("ERROR ON SAVE TICKET", e)
          if(!(e&&e.status&&e.status==401))
            Util.showNoty(ERROR, "No se pudo guardar el/los ticket/s.")
        }
      )
      
    }
  }

  isValidSearch(){
    let isValid = true
    if(this.state.tabSel){//Masiva
      if(!this.state.ticketTypeSel){
        this.setState({ticketTypeError:"Debe seleccionar un tipo de ticket"})
        isValid = false
      }
      if(!this.state.ticketCount||typeInteger(this.state.ticketCount)||this.state.ticketCount<=0){
        this.setState({ticketCountError:"Debe ingresar un valor numérico positivo"})
        isValid = false
      }
      let emails = this.state.search&&this.state.search.split(",")
      if(emails){
        let wrongMails = ""
        for(let i=0;i<emails.length;i++){
          if(this.state.searchField=="E-mail"){//Emails
            let errorEmail = validateEmail(emails[i])
            if(errorEmail){
              wrongMails+=wrongMails?emails[i]:errorEmail+" "+emails[i]
              isValid=false
            }
          }else{//DU
            let errorEmail = typeInteger(emails[i])
            if(errorEmail){
              wrongMails+=wrongMails?emails[i]:errorEmail+" "+emails[i]
              isValid=false
            }
          }
        }
        this.setState({emailError:wrongMails})
      }else{
        if(this.state.searchField=="E-mail"){
          this.setState({emailError:"Debe ingresar al menos un correo electrónico."})
        }else{
          this.setState({emailError:"Debe ingresar al menos un número de documento."})
        }
        isValid=false
      }
    }else{//Individual
      if(!this.state.search){
        if(this.state.searchField=="E-mail"){
          this.setState({emailError:"Debe ingresar un correo electrónico."})
        }else{
          this.setState({emailError:"Debe ingresar un número de documento."})
        }
        isValid=false
      }else{
        if(this.state.searchField=="E-mail"){//Emails
          let errorEmail = validateEmail(this.state.search)
          console.log("ERROR MAIL VALIDADO", errorEmail)
          if(errorEmail){
            this.setState({emailError:errorEmail})
            isValid=false
          }
        }else{//DU
          let errorEmail = typeInteger(this.state.search)
          if(errorEmail){
            this.setState({emailError:errorEmail})
            isValid=false
          }
        }
      }
    }
    return isValid
  }

  onSearchUser(){
    if(this.isValidSearch()){
      let usersDU = ""
      let usersEmail = ""
      if(this.state.searchField=="E-mail"){
        usersEmail = this.state.search
      }else{
        usersDU = this.state.search
      }
      this.props.actionGetUsersByEmailOrDU(usersDU, usersEmail,
        this.getUsersByEmailOrDUSuccess,
        (e)=>{
          console.log("ERROR ON SEARCH USER", e)
          if(!(e&&e.status&&e.status==401))
            Util.showNoty(ERROR, "No se encontró el usuario.")
        }
      )
    }
  }

  getUsersByEmailOrDUSuccess(data){
    if(!this.state.tabSel){//Individual
      if(data&&data.users&&data.users.length>0){
        this.setState({userSel:data.users[0], usersData:null})//pongo usersData en null porque en individual no se acumula.
      }else{
        if(data&&data.usersToInvite&&data.usersToInvite.length>0){
          this.setState({userSel:{...data.usersToInvite[0], proName:"Invitado no registrado"}, usersData:null})//pongo usersData en null porque en individual no se acumula.
        }
      }
    }
    this.uploadAttachCallback(data)
  }

  onChangeTicketType(evt){
    let usersData = {...this.state.usersData}
    let type = evt.target.value
    if(!this.state.tabSel){
      if(this.setState.usersData){
        if(this.setState.usersData.users&&this.setState.usersData.users.length>0){
          usersData.users[0]={...usersData.users[0],
                              tktTypeId: type.id,
                              tktPrice: type.tktPrice,
                              tktDisplayName: type.tktDisplayName,
                              tktCategory: type.tktCategory}

        }else{
          if(this.setState.usersData.usersToInvite&&this.setState.usersData.usersToInvite.length>0){
            usersData.usersToInvite[0]={...usersData.usersToInvite[0],
                                tktTypeId: type.id,
                                tktPrice: type.tktPrice,
                                tktDisplayName: type.tktDisplayName,
                                tktCategory: type.tktCategory}
  
          }
        }
      }
    }
    this.setState({ticketTypeSel:type, ticketTypeError:"", usersData:usersData}) 
  }

  onChangeSearch(evt){
    let txt = evt.target.value||""
    this.setState({search:txt.trim(), emailError:""})
  }

  onChangeCount(evt){
    this.setState({ticketCount:evt.target.value, ticketCountError:""})
  }

  onUploadExcel(evt){
    evt.preventDefault();
    let f = evt.target.files[0]
    if (f) {
      this.props.actionGetUsersFromExcel(f,this.uploadAttachCallback,(e)=>{console.log("ERROR", e)});
    }
  }

  onClickUploadExcel(evt){
    if(this.state.ticketTypeSel){
      this.inputFile&&this.inputFile.click()
    }else{
      this.setState({ticketTypeError:"Debe seleccionar un tipo de ticket"})
    }
  }

  uploadAttachCallback(data){
    let type = this.state.ticketTypeSel
    let idx = -1
    //Usuarios
    let users = this.state.usersData&&this.state.usersData.users&&this.state.usersData.users.slice(0)||[]
    for(let i = 0;i<data.users.length;i++){
      let user = data.users[i]
      let ticketCount = parseInt(user.ticketCount||this.state.ticketCount)
      if(this.state.usersData&&this.state.usersData.users){
        idx = this.state.usersData.users.findIndex((u)=>{return u.tktTypeId == type.id && u.proEmail == user.proEmail})
      }
      if(idx>=0){
        users[idx].ticketCount+=ticketCount
      }else{
        users.push(
          {
            tktTypeId: type&&type.id,
            tktPrice: type&&type.tktPrice,
            tktDisplayName: type&&type.tktDisplayName,
            tktCategory: type&&type.tktCategory,
            ...user,
            ticketCount: ticketCount, 
          }
        )
      }
    }
    //Invitados
    let usersToInvite = this.state.usersData&&this.state.usersData.usersToInvite&&this.state.usersData.usersToInvite.slice(0)||[]
    idx=-1
    for(let i = 0;i<data.usersToInvite.length;i++){
      let user = data.usersToInvite[i]
      let ticketCount = parseInt(user.ticketCount||this.state.ticketCount)
      if(this.state.usersData&&this.state.usersData.usersToInvite){
        idx = this.state.usersData.usersToInvite.findIndex((u)=>{return u.tktTypeId == type.id &&(u.proEmail == user.proEmail || u.proDNI == user.proDNI)})
      }
      if(idx>=0){
        usersToInvite[idx].ticketCount+=ticketCount
      }else{
        usersToInvite.push(
          {
            tktTypeId: type&&type.id,
            tktPrice: type&&type.tktPrice,
            tktDisplayName: type&&type.tktDisplayName,
            tktCategory: type&&type.tktCategory,
            ...user,
            ticketCount: ticketCount, 
          }
        )
      }
    }
   
    this.setState({usersData:{users:users,usersToInvite:usersToInvite}}, this.onChangePage)
  }

  renderIndividualForm(){
    const {theme, ticketTypeList} = this.props
    return (
      <form style={theme.paper.form}>  
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <FormControl fullWidth error={this.state.ticketTypeError?true:false}>
              <InputLabel shrink fullWidth>Tipo de ticket</InputLabel>
              <Select onChange={this.onChangeTicketType} fullWidth>
                {ticketTypeList&&ticketTypeList.map((c)=>{
                  return <MenuItem value={c}>{c.tktDisplayName}</MenuItem>
                })}
              </Select>
              <FormHelperText>{this.state.ticketTypeError}</FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={8}>  
            <FormControl fullWidth error={this.state.emailError?true:false}>
              <InputLabel shrink fullWidth>Usuario</InputLabel>
              <Input fullWidth onChange={this.onChangeSearch}
                    value={this.state.search} 
                    startAdornment= {
                                    <InputAdornment position="start">
                                      <Select onChange={(evt)=>{this.setState({searchField:evt.target.value, search:"", emailError:""})}} value={this.state.searchField}>
                                        <MenuItem value="DU">DU</MenuItem>
                                        <MenuItem value="E-mail">E-mail</MenuItem>
                                      </Select>  
                                    </InputAdornment>
                                    }
                    endAdornment={ 
                                    <InputAdornment position="end">
                                      <IconButton onClick={this.onSearchUser}>
                                        <SearchIcon/>
                                      </IconButton>
                                    </InputAdornment> 
                                  }
              />
              <FormHelperText>{this.state.emailError}</FormHelperText>
            </FormControl>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          {this.state.ticketTypeSel&&
            <Grid item xs={4}>
              <Typography>Valor: {Util.formatCurrency(this.state.ticketTypeSel.tktPrice)}</Typography>
              <Typography>Categoría: {this.state.ticketTypeSel.tktCategory}</Typography>
            </Grid>
          }
          {this.state.userSel&&
            <Grid item xs={8}>
              <Typography>Nombre: {this.state.userSel.proName} {this.state.userSel.proLastName}</Typography>
              <Typography>E-mail: {this.state.userSel.proEmail} </Typography>
              <Typography>DU: {this.state.userSel.proDNI} </Typography>
            </Grid>
          }
        </Grid>
      </form>
    )
  }

  renderBulkForm(){
    const {theme, ticketTypeList} = this.props
    return (
      <form style={theme.paper.form}>  
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <FormControl fullWidth error={this.state.ticketTypeError?true:false}>
              <InputLabel shrink fullWidth>Tipo de ticket</InputLabel>
              <Select onChange={this.onChangeTicketType} fullWidth >
                {ticketTypeList&&ticketTypeList.map((c)=>{
                  return <MenuItem value={c}>{c.tktDisplayName}</MenuItem>
                })}
              </Select>
              <FormHelperText>{this.state.ticketTypeError}</FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={2}>  
            <FormControl fullWidth error={this.state.ticketCountError?true:false}>
              <InputLabel shrink fullWidth>Cantidad</InputLabel>
              <Input fullWidth onChange={this.onChangeCount} 
                    value={this.state.ticketCount} 
              />
              <FormHelperText>{this.state.ticketCountError}</FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={5}>  
            <FormControl fullWidth error={this.state.emailError?true:false}>
              <InputLabel shrink fullWidth>Usuario</InputLabel>
              <Input fullWidth onChange={this.onChangeSearch} 
                    value={this.state.search} 
                    startAdornment= {
                                    <InputAdornment position="start">
                                      <Select onChange={(evt)=>{this.setState({searchField:evt.target.value, search:"", emailError:""})}} value={this.state.searchField}>
                                        <MenuItem value="DU">DU</MenuItem>
                                        <MenuItem value="E-mail">E-mail</MenuItem>
                                      </Select>  
                                    </InputAdornment>
                                    }
              />
              <FormHelperText>{this.state.emailError}</FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={1}>
            <Tooltip title={this.tabSel?"Agregar tickets":"Buscar usuario"}>
              <IconButton onClick={this.onSearchUser}>
                <AddIcon/>
              </IconButton>
            </Tooltip>
          </Grid>
          <Grid item xs={1}>
            <input type="file" ref={(r)=>{this.inputFile=r}} style={{display:"none"}} accept=".xlsx" onChange={this.onUploadExcel}/>
            <Tooltip title="Cargar excel">
              <IconButton onClick={this.onClickUploadExcel}>
                <SvgIcon viewBox="0 0 384 512">
                  <path fill="currentColor" d="M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm212-240h-28.8c-4.4 0-8.4 2.4-10.5 6.3-18 33.1-22.2 42.4-28.6 57.7-13.9-29.1-6.9-17.3-28.6-57.7-2.1-3.9-6.2-6.3-10.6-6.3H124c-9.3 0-15 10-10.4 18l46.3 78-46.3 78c-4.7 8 1.1 18 10.4 18h28.9c4.4 0 8.4-2.4 10.5-6.3 21.7-40 23-45 28.6-57.7 14.9 30.2 5.9 15.9 28.6 57.7 2.1 3.9 6.2 6.3 10.6 6.3H260c9.3 0 15-10 10.4-18L224 320c.7-1.1 30.3-50.5 46.3-78 4.7-8-1.1-18-10.3-18z"/>
                </SvgIcon>  
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Tabs value={this.state.tableTabSel} 
                onChange={(evt, v)=>{this.setState({tableTabSel:v}, this.onChangePage)}}>
            <Tab value={0} label="Tickets" style={{minWidth:0}}></Tab>
            <Badge badgeContent={this.state.usersData&&this.state.usersData.users&&this.state.usersData.users.length||0} 
                  color="primary" style={{marginTop:10, marginRight:10}}>
              
            </Badge>
            <Tab value={1} label="Invitaciones" style={{minWidth:0}}></Tab>
            <Badge badgeContent={this.state.usersData&&this.state.usersData.usersToInvite&&this.state.usersData.usersToInvite.length||0} 
                   color="primary"  style={{marginTop:10, marginRight:10}}>
              
            </Badge>
          </Tabs>
          <Table stickyHeader>
            <TableHead > 
              {this.renderTableHeader()}
            </TableHead>
            <TableBody>
              {this.renderTableBody()}
            </TableBody>
          </Table> 
          <TablePagination
            rowsPerPageOptions={[5, 10, 25, 100]}
            component="div"
            count={this.state.count}
            rowsPerPage={this.state.rowPerPage}
            page={this.state.page}
            onChangePage={this.onChangePage}
            onChangeRowsPerPage={this.onChangeRowsPerPage}
          />
        </Grid>
      </form>
            )
  }

  renderTableHeader(){
    const {theme} = this.props
    const headers = ["Tipo de Ticket", "Categoría", "E-mail", "DNI", "Nombre y Apellido", "Cantidad", "Valor", "Total"]
    return (
    <TableRow>
      {headers.map((label)=>{
        return (
          <TableCell>{label}</TableCell>
        )
      })}
      <TableCell style={theme.table.actionsColumn}>Acciones</TableCell>
    </TableRow>
    )
  }

  renderTableBody(){
    const {theme} = this.props
    let tickets = this.state.tickets
    if(!tickets||tickets.length==0){
      return <Box style={theme.table.empty}>Seleccione el tipo de ticket y el/los usuario/s para agregar tickets</Box>
    }
    return tickets.map((item, index)=>{
      let isActive=item.tktState
      return (
        <TableRow style={index%2==0?theme.table.row:theme.table.rowColor}>
          <TableCell>{item.tktDisplayName}</TableCell>
          <TableCell>{item.tktCategory}</TableCell>
          <TableCell>{item.proEmail}</TableCell>
          <TableCell>{item.proDNI}</TableCell>
          <TableCell>{item.proName} {item.proLastName}</TableCell>
          <TableCell>{Util.formatNumber(item.ticketCount)}</TableCell>
          <TableCell>{Util.formatCurrency(item.tktPrice)}</TableCell>
          <TableCell>{Util.formatCurrency(item.tktPrice*item.ticketCount)}</TableCell>
          <TableCell style={{...theme.table.actionsColumn, minWith:200}}>
            <Tooltip title="Eliminar ticket">
              <IconButton onClick={this.onDeleteTicket.bind(this, item)}>
                <DeleteIcon/>
              </IconButton>
            </Tooltip>
          </TableCell>
        </TableRow>
      )
    })
  }

  onDeleteTicket(item){
    let tickets = this.state.ticketList.filter((t)=>{return !(t.tktTypeId==item.tktTypeId&&t.id==item.id)})
    this.setState({ticketList:tickets})
    this.onChangePage()
  }

  render(){
    const { theme, handleSubmit, event, ticketFormValues } = this.props
    return (
      <Box style={theme.mainContainer}>
        <Box style={{...theme.title.container, flexDirection:"row", display:"flex"}}>
          <Box style={theme.title.backIconContainer}>
            <Tooltip title="Atrás">
              <IconButton onClick={this.props.history.goBack} style={theme.title.backIcon}>
                <BackIcon style={{fontSize:"2.5rem"}} stroke="white" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round"/>
              </IconButton>
            </Tooltip>  
          </Box>
          <Box>
            <Typography variant="h1">{event&&event.evtName}</Typography>
            <Typography variant="subtitle1">Crea tickets para el evento seleccionado</Typography>
          </Box>
        </Box>
        <Container>        
          <Paper >
            <Box style={theme.paper.addEditTicketTypeTitle}>
              <Typography style={theme.paper.title} variant="h2">Crear ticket</Typography>
              <Typography style={theme.paper.title} variant="h2" >Fecha del evento: {event&&Util.formatDateToShow(Util.timestampToMoment(event.evtDateTime))}</Typography>
            </Box>
            <Tabs value={this.state.tabSel} onChange={(evt, v)=>{this.setState({tabSel:v})}} indicatorColor="primary">
              <Tab value={0} label="Carga Individual"></Tab>
              <Tab value={1} label="Carga Masiva"></Tab>
            </Tabs>
            {this.state.tabSel?this.renderBulkForm():this.renderIndividualForm()}
          </Paper>
          <Toolbar style={theme.footer.toolbar}>
            <Tooltip title="Limpiar">
              <Button variant="contained" color="secondary" style={theme.footer.button} onClick={this.onClean}>Limpiar</Button>
            </Tooltip>
            <Tooltip title="Cancelar">
              <Button variant="contained" color="secondary" style={theme.footer.button} onClick={this.props.history.goBack}>Cancelar</Button>
            </Tooltip>
            <Tooltip title="Guardar">
              <Button variant="contained" color="primary" style={theme.footer.button} onClick={handleSubmit(this.onSave)}>Guardar</Button>
            </Tooltip>                  
          </Toolbar>
        </Container>
      </Box>
    )
  }
}
function mapStateToProps(store) {
  // console.log("STORE", store)
  return {
    login: store.auth.login,
    event: store.evt.event,
    ticketFormValues: store.form&&store.form.addEditTicket&&store.form.addEditTicket.values,
    ticketTypeList: store.evt.ticketTypeList,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      actionGetTicketTypes,
      actionSaveTickets,
      actionGetUsersByEmailOrDU,
      actionGetUsersFromExcel
    },
    dispatch
  );
}

export default  reduxForm({
  form: "addEditTicket",
  onSubmitFail: errors => _handleSubmitFail(errors)
})(withRouter(
    withTheme(
      connect(
        mapStateToProps,
        mapDispatchToProps
      )(AddEditTicket)
    )
  )
)


// WEBPACK FOOTER //
// ./src/screens/restaurants/AddEditTicket.js